// src/redux/slices/authSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { ApiBaseUrl, getBidListingProfessional } from "../../Utils/Constants";
import { toast } from "react-toastify";

export const hitGetBidListingProfessionalApi = createAsyncThunk(
  "hitGetBidListingProfessionalApi",
  async (payload) => {
    try {
      const config = {
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
          Authorization: `${localStorage.getItem("professionalToken")}`,
        },
        params: payload,
      };
      const url = ApiBaseUrl + getBidListingProfessional;
      const response = await axios.get(url, config);
      return response.data;
    } catch (error) {
      toast.error(error.response.data.message);
      throw error.response.data;
    }
  }
);

const GetBidListProfessionalSlice = createSlice({
  name: "getBidListProfessionalReducer",
  initialState: {
    isLoading: false,
    data: null,
  },
  reducers: {
    clearhitGetBidListData: (state) => {
      state.data = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(hitGetBidListingProfessionalApi.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(hitGetBidListingProfessionalApi.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      })
      .addCase(hitGetBidListingProfessionalApi.rejected, (state) => {
        state.isError = false;
      });
  },
});

export const { clearhitGetBidListData } = GetBidListProfessionalSlice.actions;
export default GetBidListProfessionalSlice.reducer;
